const OAUTH_AUTHORIZATION_PATH = '/oauth/authorize';

export function isOAuthAuthorizationPath(pathname: string | null | undefined): boolean {
	return pathname === OAUTH_AUTHORIZATION_PATH || pathname?.startsWith(`${OAUTH_AUTHORIZATION_PATH}/`) === true;
}
